import { ReactComponent as Angular } from "../assets/icons/angular.svg";
import { ReactComponent as AWS } from "../assets/icons/aws.svg";
import { ReactComponent as Bitbucket } from "../assets/icons/bitbucket.svg";
import { ReactComponent as ChartJs } from "../assets/icons/charJs.svg";
import { ReactComponent as Cloudwatch } from "../assets/icons/cloudwatch.svg";
import { ReactComponent as Confluence } from "../assets/icons/confluence.svg";
import { ReactComponent as CSS } from "../assets/icons/css.svg";
import { ReactComponent as EC2 } from "../assets/icons/ec2.svg";
import { ReactComponent as Electron } from "../assets/icons/electron.svg";
import { ReactComponent as EsLint } from "../assets/icons/eslint.svg";
import { ReactComponent as Express } from "../assets/icons/express.svg";
import { ReactComponent as Git } from "../assets/icons/git.svg";
import { ReactComponent as GitHub } from "../assets/icons/github.svg";
import { ReactComponent as HTML } from "../assets/icons/html.svg";
import { ReactComponent as Javascript } from "../assets/icons/javascript.svg";
import { ReactComponent as Jenkins } from "../assets/icons/jenkins.svg";
import { ReactComponent as Jest } from "../assets/icons/jest.svg";
import { ReactComponent as Jira } from "../assets/icons/jira.svg";
import { ReactComponent as Lambda } from "../assets/icons/lambda.svg";
import { ReactComponent as Mongodb } from "../assets/icons/mongodb.svg";
import { ReactComponent as MySQL } from "../assets/icons/mysql.svg";
import { ReactComponent as NgRx } from "../assets/icons/ngrx.svg";
import { ReactComponent as Node } from "../assets/icons/node.svg";
import { ReactComponent as NPM } from "../assets/icons/npm.svg";
import { ReactComponent as P5Js } from "../assets/icons/p5Js.svg";
import { ReactComponent as Postman } from "../assets/icons/postman.svg";
import { ReactComponent as ReactIcon } from "../assets/icons/react.svg";
import { ReactComponent as Redux } from "../assets/icons/redux.svg";
import { ReactComponent as RestApi } from "../assets/icons/restApi.svg";
import { ReactComponent as RxJs } from "../assets/icons/rxjs.svg";
import { ReactComponent as S3 } from "../assets/icons/s3.svg";
import { ReactComponent as Sass } from "../assets/icons/sass.svg";
import { ReactComponent as Typescript } from "../assets/icons/typescript.svg";
import { ReactComponent as VsCode } from "../assets/icons/vscode.svg";
import { ReactComponent as Webpack } from "../assets/icons/webpack.svg";
import { ReactComponent as WebSocket } from "../assets/icons/websocket.svg";
import { ReactComponent as Yarn } from "../assets/icons/yarn.svg";

export const SkillArray = [
  { label: "html-5", icon: <HTML width={20} height={20} /> },
  { label: "css-3", icon: <CSS width={20} height={20} /> },
  { label: "JavaScript", icon: <Javascript width={20} height={20} /> },
  { label: "Sass", icon: <Sass width={20} height={20} /> },
  { label: "TypeScript", icon: <Typescript width={20} height={20} /> },
  { label: "Angular", icon: <Angular width={20} height={20} /> },
  { label: "React", icon: <ReactIcon width={20} height={20} /> },
  { label: "Node.js", icon: <Node width={20} height={20} /> },
  { label: "AWS", icon: <AWS width={20} height={20} /> },
  { label: "Git", icon: <Git width={20} height={20} /> },
  { label: "Express.js", icon: <Express width={20} height={20} /> },
  { label: "Redux", icon: <Redux width={20} height={20} /> },
  { label: "NgRx", icon: <NgRx width={20} height={20} /> },
  { label: "Electron.js", icon: <Electron width={20} height={20} /> },
  { label: "mongoDB", icon: <Mongodb width={20} height={20} /> },
  { label: "MySQL", icon: <MySQL width={20} height={20} /> },
  { label: "REST api", icon: <RestApi width={20} height={20} /> },
  { label: "EC2", icon: <EC2 width={20} height={20} /> },
  { label: "Cloudwatch", icon: <Cloudwatch width={20} height={20} /> },
  { label: "S3", icon: <S3 width={20} height={20} /> },
  { label: "Lambda", icon: <Lambda width={20} height={20} /> },
  { label: "Postman", icon: <Postman width={20} height={20} /> },
  { label: "Jest", icon: <Jest width={20} height={20} /> },
  { label: "websocket", icon: <WebSocket width={20} height={20} /> },
  { label: "Jenkins", icon: <Jenkins width={20} height={20} /> },
  { label: "p5.js", icon: <P5Js width={20} height={20} /> },
  { label: "char.js", icon: <ChartJs width={20} height={20} /> },
  { label: "npm", icon: <NPM width={20} height={20} /> },
  { label: "yarn", icon: <Yarn width={20} height={20} /> },
  { label: "RxJs", icon: <RxJs width={20} height={20} /> },
  { label: "Jira", icon: <Jira width={20} height={20} /> },
  { label: "Confluence", icon: <Confluence width={20} height={20} /> },
  { label: "Bitbucket", icon: <Bitbucket width={20} height={20} /> },
  { label: "Vscode", icon: <VsCode width={20} height={20} /> },
  { label: "Github", icon: <GitHub width={20} height={20} /> },
  { label: "EsLint", icon: <EsLint width={20} height={20} /> },
  { label: "Webpack", icon: <Webpack width={20} height={20} /> },
];
